"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StorytellingCapabilities() {
  const {
    ref: row1TextRef,
    isVisible: row1TextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: row1ImgRef,
    isVisible: row1ImgVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: row2TextRef,
    isVisible: row2TextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: row2ImgRef,
    isVisible: row2ImgVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="222659" id="familiar-channels-new-power" className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="max-w-6xl mx-auto px-6">
        
        {}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-20 items-center mb-20 md:mb-32">
          <div ref={row1TextRef} className={`transition-all duration-700 ease-out ${row1TextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <span className="font-default text-sm tracking-widest uppercase text-primary mb-4 block">
              Familiar Channels
            </span>
            <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 leading-tight">
              Onboard via the apps you already live in.
            </h2>
            <p className="font-default text-lg text-muted-foreground mb-8 leading-relaxed">
              Stay in your flow. Whether it's iMessage or Slack, OceanWallet brings crypto payments and AI commerce directly to your private threads. No new apps to learn, just immediate power.
            </p>
            <Button asChild variant="outline" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground rounded-xl h-auto py-3 px-8 text-sm font-semibold tracking-widest uppercase transition-all shadow-lg shadow-primary/10">
              <Link to="#">GET STARTED</Link>
            </Button>
          </div>
          
          <div ref={row1ImgRef} className={`transition-all duration-700 delay-200 ease-out h-full min-h-[300px] md:min-h-[400px] ${row1ImgVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1636402/img/storytelling_charities_brands.png" alt="iMessage payment approval interface" className="w-full h-full object-cover rounded-xl shadow-2xl border border-white/5 backdrop-blur-sm" />
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-20 items-center">
          <div ref={row2ImgRef} className={`order-last md:order-first transition-all duration-700 ease-out h-full min-h-[300px] md:min-h-[400px] ${row2ImgVisible ? "opacity-100 -translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1636402/img/storytelling_real_impact.png" alt="Slack managed tenant notification" className="w-full h-full object-cover rounded-xl shadow-2xl border border-white/5 backdrop-blur-sm" />
          </div>
          
          <div ref={row2TextRef} className={`transition-all duration-700 delay-200 ease-out ${row2TextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <span className="font-default text-sm tracking-widest uppercase text-primary mb-4 block">
              Instant Infrastructure
            </span>
            <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 leading-tight">
              Managed capability. Zero friction.
            </h2>
            <p className="font-default text-lg text-muted-foreground mb-8 leading-relaxed">
              Every purchase creates a tenant-based managed experience. From identity and entitlements to workspace assignment and policy controls, OceanClaw handles the complexity while you stay in control.
            </p>
            <Button asChild variant="outline" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground rounded-xl h-auto py-3 px-8 text-sm font-semibold tracking-widest uppercase transition-all shadow-lg shadow-primary/10">
              <Link to="#">EXPLORE OCEANCLAW</Link>
            </Button>
          </div>
        </div>

      </div>
    </section>;
}